/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="1110" height="114" {...props}>
    <circle
      cx="20.106"
      cy="20.106"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="20.106"
      cy="93.826"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="247.133"
      cy="20.106"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="247.133"
      cy="93.826"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="474.16"
      cy="20.106"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="474.16"
      cy="93.826"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="701.184"
      cy="20.106"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="701.184"
      cy="93.826"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="928.211"
      cy="20.106"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <circle
      cx="928.211"
      cy="93.826"
      r="17.593"
      stroke="#05F"
      strokeWidth="5.026"
    ></circle>
    <rect
      width="145.766"
      height="40.211"
      x="56.129"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="56.129"
      y="73.721"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="283.156"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="283.156"
      y="73.721"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="510.18"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="510.18"
      y="73.721"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="737.207"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="737.207"
      y="73.721"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="964.234"
      fill="#05F"
      rx="8.377"
    ></rect>
    <rect
      width="145.766"
      height="40.211"
      x="964.234"
      y="73.721"
      fill="#05F"
      rx="8.377"
    ></rect>
    <path
      fill="#05F"
      d="M16.657 28.481L9.33 21.154a1.127 1.127 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936L28.026 12.33c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594L18.25 28.481c-.44.44-1.154.44-1.594 0zm0 74L9.33 95.154a1.127 1.127 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936L28.026 86.33c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594L18.25 102.481c-.44.44-1.154.44-1.594 0zm454-74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm0 74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm-227-74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm0 74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm454-74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm0 74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm227-74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0zm0 74l-7.327-7.327a1.128 1.128 0 010-1.594l1.594-1.594c.44-.44 1.154-.44 1.594 0l4.936 4.936 10.572-10.572c.44-.44 1.154-.44 1.594 0l1.594 1.594c.44.44.44 1.154 0 1.594l-12.963 12.963c-.44.44-1.154.44-1.594 0z"
    ></path>
  </Svg>
)

export default Icon
